module.exports = __webpack_public_path__ + "media/slider/Subscription-1-US-2a9b53d1.jpg";